import Vue from 'vue'
import VueTk from '@moke/vue-tk'
import router from '../router'
import config from '../config'
import '@moke/vue-tk/dist/vue-tk.css'
Vue.use(VueTk)
const options = {
  vue: Vue, // vue示例，tkAjax 的必需项
  router: router, // tkHistory 与 tkRouterAuth 的必需项
  icon: { // 图标配置
    ctoken: config.iconCToken,
    EGG_SESS: config.iconEggSess,
    custom: { // 自定义图标，参考tkIcon配置项
      default: {
        data: config.iconJSON
      }
    }
  },
  ajax: { // tkAjax配置项
    global: { // 全局ajax配置
      headers: {}
    }
  },
  parse: { // tkParse配置项
    appId: config.appID,
    restKey: config.restKey,
    masterKey: config.masterKey,
    baseURL: config.apiUrl,
    model: config.modelJSON
  }
}
VueTk.init(options)
